<template lang="pug">
section
  .container.position-relative
    .title_wrapper.d-md-none
      h1 {{ homeData.area01_Title }}
      p(v-html="homeData.area01_SubTitle")
    .circles_wrapper
      .main_circle
        .sub_circle.img(
          :style="{ backgroundImage: 'url(' + circleImage + ')' }"
        )
        svg-icon(iconClass="home_sm_circle", className="sm_circle")
        svg-icon(iconClass="home_md_circle", className="md_circle")
        svg-icon(iconClass="home_lg_circle", className="lg_circle")
        svg-icon(iconClass="home_oval_circle", className="oval_circle")
        svg-icon(iconClass="home_oval_circle_o", className="oval_circle_o")
    .title_wrapper.d-none.d-md-block
      h1 {{ homeData.area01_Title }}
      p(v-html="homeData.area01_SubTitle")
    .tab_wrapper.text-left
      .container
        .row
          .col-4(v-for="(tab, index) in insuranceList", :key="index")
            tab(:tab="tab", @mouseover.native="tabHover(tab)", @click.native="tabClick(tab)")
</template>

<script>
import Tab from "@/components/home/Tab";

export default {
  name: "Home",
  components: { tab: Tab },
  props: {
    homeData: Object,
  },
  data() {
    return {
      insuranceList: [],
      circleImage: "",
    };
  },
  watch: {
    homeData() {
      this.getInsuranceList();
    },
  },
  methods: {
    getInsuranceList() {
      this.insuranceList = [];

      let carModel = {
        area01_ProductName: this.homeData.area01_ProductName01,
        area01_ProductIcon: this.homeData.area01_ProductIcon01,
        area01_ProductImage: this.homeData.area01_ProductImage01,
        area01_ProductURL: this.homeData.area01_ProductURL01,
      };
      this.insuranceList.push(carModel);

      let motoModel = {
        area01_ProductName: this.homeData.area01_ProductName02,
        area01_ProductIcon: this.homeData.area01_ProductIcon02,
        area01_ProductImage: this.homeData.area01_ProductImage02,
        area01_ProductURL: this.homeData.area01_ProductURL02,
      };
      this.insuranceList.push(motoModel);

      let travelModel = {
        area01_ProductName: this.homeData.area01_ProductName03,
        area01_ProductIcon: this.homeData.area01_ProductIcon03,
        area01_ProductImage: this.homeData.area01_ProductImage03,
        area01_ProductURL: this.homeData.area01_ProductURL03,
      };
      this.insuranceList.push(travelModel);

      let houseModel = {
        area01_ProductName: this.homeData.area01_ProductName04,
        area01_ProductIcon: this.homeData.area01_ProductIcon04,
        area01_ProductImage: this.homeData.area01_ProductImage04,
        area01_ProductURL: this.homeData.area01_ProductURL04,
      };
      this.insuranceList.push(houseModel);

      let damageModel = {
        area01_ProductName: this.homeData.area01_ProductName05,
        area01_ProductIcon: this.homeData.area01_ProductIcon05,
        area01_ProductImage: this.homeData.area01_ProductImage05,
        area01_ProductURL: this.homeData.area01_ProductURL05,
      };
      this.insuranceList.push(damageModel);

      let anotherModel = {
        area01_ProductName: this.homeData.area01_ProductName06,
        area01_ProductIcon: this.homeData.area01_ProductIcon06,
        area01_ProductImage: this.homeData.area01_ProductImage06,
        area01_ProductURL: this.homeData.area01_ProductURL06,
      };
      this.insuranceList.push(anotherModel);

      this.circleImage = this.homeData.area01_ProductImage01;
    },
    tabHover(tab) {
      this.circleImage = tab.area01_ProductImage;
    },
    tabClick(tab) {
      this.circleImage = tab.area01_ProductImage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/services";
</style>
